import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/AuthContext";

import Welcome from "@/pages/Welcome";
import Diagnostic from "@/pages/Diagnostic";
import Submitted from "@/pages/Submitted";
import DiagnosticResult from "@/pages/DiagnosticResult";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSections from "@/pages/AdminSections";
import AdminQuestions from "@/pages/AdminQuestions";
import AdminOptions from "@/pages/AdminOptions";
import AdminProducts from "@/pages/AdminProducts";
import AdminUsers from "@/pages/AdminUsers";
import AdminMaturity from "@/pages/AdminMaturity";
import AdminDiagnosticDetail from "@/pages/AdminDiagnosticDetail";
import AdminReport from "@/pages/AdminReport";
import AdminProposta from "@/pages/AdminProposta";

const ProtectedRoute = () => {
  const { user, checking } = useAuth();
  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-[#6B8DB3]">
        Verificando sessão...
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
};

const AdminOnlyRoute = () => {
  const { user } = useAuth();
  if (user?.role !== "admin") return <Navigate to="/admin" replace />;
  return <Outlet />;
};

const AdminOrGestorRoute = () => {
  const { user } = useAuth();
  if (!["admin", "gestor"].includes(user?.role)) return <Navigate to="/admin" replace />;
  return <Outlet />;
};

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div className="App">
      <Toaster
        theme="dark"
        position="top-right"
        toastOptions={{
          style: {
            background: "#1C1F26",
            border: "1px solid #3A3F47",
            color: "#fff",
          },
        }}
      />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/diagnostico" element={<Diagnostic />} />
            <Route path="/diagnostico/enviado/:id" element={<Submitted />} />
            <Route path="/diagnostico/resultado/:id" element={<DiagnosticResult />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route element={<ProtectedRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<AdminDashboard />} />
                <Route element={<AdminOrGestorRoute />}>
                  <Route path="/admin/sessoes" element={<AdminSections />} />
                  <Route path="/admin/perguntas" element={<AdminQuestions />} />
                  <Route path="/admin/listas" element={<AdminOptions />} />
                  <Route path="/admin/produtos" element={<AdminProducts />} />
                  <Route path="/admin/maturidade" element={<AdminMaturity />} />
                </Route>
                <Route element={<AdminOnlyRoute />}>
                  <Route path="/admin/usuarios" element={<AdminUsers />} />
                </Route>
                <Route
                  path="/admin/diagnosticos/:id"
                  element={<AdminDiagnosticDetail />}
                />
              </Route>
              {/* Print-friendly routes (full screen, no sidebar) */}
              <Route
                path="/admin/diagnosticos/:id/relatorio"
                element={<AdminReport />}
              />
              <Route
                path="/admin/diagnosticos/:id/proposta"
                element={<AdminProposta />}
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
